const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/client/checklists.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/client/checklists")({
  beforeLoad: args => requirePermission(Permissions.Support.ViewClientData, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/**
 * Client checklists (founder, 2026-09-14): the tenant's checklists with type,
 * layout, question count, library source and status, and per-row Print
 * (paper form / detailed / issue types PDF) and Edit in the client app.
 * Data: Client `Checklist/GetAll` through the admin `GET /checklists` proxy.
 */